import useSelection from "antd/lib/table/hooks/useSelection";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Button, Col, Container, Row } from "reactstrap";

const Price = (props) => {
  const user = useSelector((state) => state.authUser);
  //   console.log("idd", user?.id);
  return (
    <>
      <div id="price" className="mt-5">
        <Container>
          <div style={{ width: "100%" }} className="text-center mx-auto">
            <h1
              className="text-uppercase section-title"
              style={{
                fontFamily: "Ogg",
                letterSpacing: 6,
                wordSpacing: 8,
              }}
            >
              A membership plan
              <br />
              for everyone
            </h1>
            <p>We offer a range of plans to fit your priorities and pocket</p>
          </div>
          <Row className="mt-5">
            <Col md="6">
              <h4 className="m-0 font-weight-bold" style={{ color: "#5E5E5E" }}>
                Free Plan
              </h4>
              <p>So everyone can capture their story</p>
              <div className="mt-5">
                <h1
                  className="font-weight-bold mb-0"
                  style={{ color: "#D93D13", fontSize: 52 }}
                >
                  <span style={{ fontSize: 16 }}>$</span>0
                </h1>
                <small>per month</small>
              </div>
            </Col>
            <Col md="6">
              <div className="d-flex align-items-center">
                <span className="mr-2" style={{ color: "#D93D13" }}>
                  <i className="fa fa-check"></i>
                </span>
                10GB Bandwidth Internet
              </div>
              <div className="mt-3 d-flex align-items-center">
                <span className="mr-2" style={{ color: "#D93D13" }}>
                  <i className="fa fa-check"></i>
                </span>
                Business & Financ Analysing
              </div>
              <div className="mt-3 d-flex align-items-center">
                <span className="mr-2" style={{ color: "#D93D13" }}>
                  <i className="fa fa-check"></i>
                </span>
                25 Social Media Reviews
              </div>
              <div className="mt-3 d-flex align-items-center">
                <span className="mr-2" style={{ color: "#D93D13" }}>
                  <i className="fa fa-check"></i>
                </span>
                Customer Managemet
              </div>
              <div className="mt-3 d-flex align-items-center">
                <span className="mr-2" style={{ color: "#D93D13" }}>
                  <i className="fa fa-check"></i>
                </span>
                24/7 Support
              </div>
            </Col>
          </Row>
          <div className="d-flex align-items-center my-5">
            <Link
              to={
                user?.id ? "/dashboard/manage-account" : "/dashboard/register"
              }
              className="mx-auto"
            >
              <Button className="btn-outline landing-btn">Get Started</Button>
            </Link>
          </div>
        </Container>
        <hr />
        <Container>
          <Row className="mt-5">
            <Col md="6">
              <h4 className="m-0 font-weight-bold" style={{ color: "#5E5E5E" }}>
                Advance Plan
              </h4>
              <p>So everyone can capture their story</p>
              <div className="mt-5">
                <h2
                  className="font-weight-bold mb-0"
                  style={{ color: "#D93D13", fontSize: 52 }}
                >
                  <span style={{ fontSize: 16 }}>$</span>39.9
                </h2>
                <small>per month</small>
              </div>
            </Col>
            <Col md="6">
              <div className="d-flex align-items-center">
                <span className="mr-2" style={{ color: "#D93D13" }}>
                  <i className="fa fa-check"></i>
                </span>
                10GB Bandwidth Internet
              </div>
              <div className="mt-3 d-flex align-items-center">
                <span className="mr-2" style={{ color: "#D93D13" }}>
                  <i className="fa fa-check"></i>
                </span>
                Business & Financ Analysing
              </div>
              <div className="mt-3 d-flex align-items-center">
                <span className="mr-2" style={{ color: "#D93D13" }}>
                  <i className="fa fa-check"></i>
                </span>
                25 Social Media Reviews
              </div>
              <div className="mt-3 d-flex align-items-center">
                <span className="mr-2" style={{ color: "#D93D13" }}>
                  <i className="fa fa-check"></i>
                </span>
                Customer Managemet
              </div>
              <div className="mt-3 d-flex align-items-center">
                <span className="mr-2" style={{ color: "#D93D13" }}>
                  <i className="fa fa-check"></i>
                </span>
                24/7 Support
              </div>
            </Col>
          </Row>
          <div className="d-flex align-items-center my-5">
            <Link
              to={
                user?.id ? "/dashboard/manage-account" : "/dashboard/register"
              }
              className="mx-auto"
            >
              <Button className="btn-outline landing-btn">Get Started</Button>
            </Link>
          </div>
        </Container>
        <hr />
        <Container>
          <Row className="mt-5">
            <Col md="6">
              <h4 className="m-0 font-weight-bold" style={{ color: "#5E5E5E" }}>
                Premium Plan
              </h4>
              <p>So everyone can capture their story</p>
              <div className="mt-5">
                <h2
                  className="font-weight-bold mb-0"
                  style={{ color: "#D93D13", fontSize: 52 }}
                >
                  <span style={{ fontSize: 16 }}>$</span>99.9
                </h2>
                <small>per month</small>
              </div>
            </Col>
            <Col md="6">
              <div className="d-flex align-items-center">
                <span className="mr-2" style={{ color: "#D93D13" }}>
                  <i className="fa fa-check"></i>
                </span>
                10GB Bandwidth Internet
              </div>
              <div className="mt-3 d-flex align-items-center">
                <span className="mr-2" style={{ color: "#D93D13" }}>
                  <i className="fa fa-check"></i>
                </span>
                Business & Financ Analysing
              </div>
              <div className="mt-3 d-flex align-items-center">
                <span className="mr-2" style={{ color: "#D93D13" }}>
                  <i className="fa fa-check"></i>
                </span>
                25 Social Media Reviews
              </div>
              <div className="mt-3 d-flex align-items-center">
                <span className="mr-2" style={{ color: "#D93D13" }}>
                  <i className="fa fa-check"></i>
                </span>
                Customer Managemet
              </div>
              <div className="mt-3 d-flex align-items-center">
                <span className="mr-2" style={{ color: "#D93D13" }}>
                  <i className="fa fa-check"></i>
                </span>
                24/7 Support
              </div>
            </Col>
          </Row>
          <div className="d-flex align-items-center my-5">
            <Link
              to={
                user?.id ? "/dashboard/manage-account" : "/dashboard/register"
              }
              className="mx-auto"
            >
              <Button className="btn-outline landing-btn">Get Started</Button>
            </Link>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Price;
